import firebase from 'firebase'
// import { store } from '../store'

const authGuard = (to, from, next) => {
  firebase.auth().onAuthStateChanged(user => {
    // if (user) {
    //   console.dir('[USER - auto sign in]', user)
    //   store.dispatch('user/autoSignIn', user)
    // }

    let currentUser = firebase.auth().currentUser
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    let isLogin = to.matched.some(record => record.meta.isLogin)

    console.log('[AUTHGUARD - CURRENT USER]', currentUser)

    if (requiresAuth && !currentUser) next({ name: 'Login' })
    if (isLogin && currentUser) next({ name: 'Home' })

    next()

    // if (currentUser) {
    //   store.dispatch('user/autoSignIn', currentUser)
    //   next()
    // } else {
    //   next()
    // }
  })
}

export default authGuard



// WEBPACK FOOTER //
// ./src/router/auth-guard.js